import React from 'react';
import PropTypes from 'prop-types';
import { fireDetailsPageComponentFailureFpti } from '../../../lib/helpers';

const DetailsTermsConditions = ({
  componentContent = {},
  fptiImpression,
  handleClickFPTI
}) => {
  const { termsText } = componentContent;

  if (!termsText) {
    fireDetailsPageComponentFailureFpti({
      data: { termsText },
      componentName: 'DetailsTermsConditions',
      fptiImpression
    });
    return null;
  }

  return (
    <section id="details-terms-conditions">
      <div className="details-terms-conditions-container">
        <div className="container-terms">
          <hr className="nav-divider" />
          <div
            dangerouslySetInnerHTML={{ __html: termsText }}
            onClick={e =>
              e.target.tagName === 'A' &&
              e.target.getAttribute('data-fptilinkname')
                ? handleClickFPTI(e.target.getAttribute('data-fptilinkname'))
                : {}
            }
            role="presentation"
          ></div>
        </div>
      </div>
    </section>
  );
};

DetailsTermsConditions.propTypes = {
  componentContent: PropTypes.object,
  termsText: PropTypes.string,
  fptiImpression: PropTypes.func.isRequired,
  handleClickFPTI: PropTypes.func
};

export default DetailsTermsConditions;
